import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { ExternalRegistrationFormComponent } from './external-registration-form/external-registration-form.component';
import { LoginComponent } from './login/login.component';
import { AuthComponent } from './auth.component';
import { NotLoggedGuard } from './services/not-logged.guard';

const routes: Routes = [
  {
    path: '',
    component: AuthComponent,
    children: [
      {path: 'login', component: LoginComponent},
    ],
  },
  {path: 'external-registration', component: ExternalRegistrationFormComponent, canActivate: [NotLoggedGuard]},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
}
